import type { YieldRange } from '~/@pages_investing/fee-immunity/feeImmunity.type'
import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { formatYieldWithImmunity } from '~/@pages_investing/fee-immunity/feeImmunityDisplay.utils'
import { FeeImmunityTooltipContent } from './FeeImmunityTooltipContent'

type Props = YieldRange & { isYieldCompoundingAnnually?: boolean }

export function FeeImmunityTooltip({
  minYieldValue,
  maxYieldValue,
  isYieldCompoundingAnnually,
}: Props) {
  const yieldRangeText =
    minYieldValue != null
      ? formatYieldWithImmunity({ minYieldValue, maxYieldValue })
      : undefined

  return (
    <TextTooltip
      text={FeeImmunityTooltipContent(
        yieldRangeText,
        isYieldCompoundingAnnually
      )}
      linkText="Zistiť viac"
      linkUrl="/fee-immunity"
      linkTarget="_self"
      iconClassName="text-white"
    />
  )
}
